import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { Fonte } from '../../types'
import { useDeleteFonte, useFonte, useUpdateFonte } from '../../hooks/fonti'
import FonteForm from '../../components/FonteForm'

export default function FonteEdit() {
  const { id } = useParams()
  const { data: fonte } = useFonte(Number(id!))
  const deleteFonte = useDeleteFonte()
  const updateFonte = useUpdateFonte()
  const [modalRm, modalRmActions] = useModalTrigger<Fonte>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/fonti">Fonti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {fonte?.nome}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(fonte)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <FonteForm
          fonte={fonte}
          save={(fonte) =>
            updateFonte.mutateAsync(fonte).then(() =>
              toast.success('Fonte aggiornata', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la fonte {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteFonte.isLoading}
            onClick={async () => {
              await deleteFonte.mutateAsync(modalRm.value!.id)
              navigate('/fonti')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
